<template>
  <div v-if="!arquivoUploaded">
    <div
      :class="['dropZone', dragging ? 'dropZone-over' : '']"
      @dragenter="dragging = true"
      @dragleave="dragging = false"
    >
      <div
        class="dropZone-info"
        @drag="onChangeFile"
      >
        <span class="fa fa-cloud-upload dropZone-title"></span>
        <span class="dropZone-title">Arraste ou clique para carregar o arquivo</span>
        <div class="dropZone-upload-limit-info">
          <div>Para imagens: .png ou .jpeg, máx 5 MB</div>
          <div>Para documentos: .pdf, máx 100 MB</div>
        </div>
      </div>
      <input
        type="file"
        accept=".png, .jpeg, .pdf"
        @change="onChangeFile"
      >
    </div>
  </div>
  <div
    v-else
    class="dropZone-uploaded"
  >
    <div class="dropZone-uploaded-info">
      <span class="dropZone-title">Arquivo carregado</span>
      <v-btn
        class=""
        outlined
        @click="removeFile"
      >
        Remover arquivo
      </v-btn>
    </div>
  </div>
</template>

<script>
import {
  inject, ref, watch,
} from '@vue/composition-api'
import Vue from 'vue'
import NodeChatBotModel from '@/models/entities/chat-bot/NodeChatBotModel'

export default {
  setup(props, { emit }) {
    const nodeDataLocale = ref(new NodeChatBotModel())
    const nodeData = inject('nodeData')
    const arquivoUploaded = ref(false)

    const dragging = ref(false)

    function nodeConfig() {
      emit('node-config')
    }

    async function createFile(fileSent) {
      if (fileSent.type.match('/png') || fileSent.type.match('/jpeg')) {
        const reader = new FileReader()
        reader.onloadend = () => {
          const dataUrl = reader.result
          const tamanhoImagemEmMB = new Blob([dataUrl]).size / 1_048_576

          if (tamanhoImagemEmMB > 5) {
            Vue.$toast.warning('A imagem não pode ter mais de 5MB.', { timeout: false })
          } else {
            nodeDataLocale.value.arquivoNome = fileSent.name
            nodeDataLocale.value.arquivoConteudo = dataUrl
            dragging.value = false
            arquivoUploaded.value = true
            nodeConfig()
          }
        }
        reader.readAsDataURL(fileSent)
      }

      if (fileSent.type.match('/pdf')) {
        const reader = new FileReader()
        reader.onloadend = () => {
          const dataUrl = reader.result
          const tamanhoImagemEmMB = new Blob([dataUrl]).size / 1_048_576

          if (tamanhoImagemEmMB > 100) {
            Vue.$toast.warning('O documento não pode ter mais de 100MB.', { timeout: false })
          } else {
            nodeDataLocale.value.arquivoNome = fileSent.name
            nodeDataLocale.value.arquivoConteudo = dataUrl
            dragging.value = false
            arquivoUploaded.value = true
            nodeConfig()
          }
        }
        reader.readAsDataURL(fileSent)
      }
    }

    function removeFile() {
      nodeDataLocale.value.arquivoConteudo = null
      nodeDataLocale.value.arquivoNome = null
      nodeDataLocale.value.arquivoStorageId = null
      arquivoUploaded.value = false
      dragging.value = true
    }

    async function onChangeFile(e) {
      const files = e.target.files || e.dataTransfer.files

      if (!files.length) {
        dragging.value = false
        return
      }

      await createFile(files[0])
    }

    watch(() => nodeData.value, value => {
      nodeDataLocale.value = value
      arquivoUploaded.value = !!nodeDataLocale.value.arquivoStorageId
    }, { immediate: true, deep: true })

    return {
      dragging,
      arquivoUploaded,
      onChangeFile,
      removeFile,
    }
  },
}
</script>

<style>
.dropZone {
  width: 100%;
  height: 200px;
  position: relative;
  border: 2px dashed #eee;
}

.dropZone:hover {
  border: 2px solid #2e94c4;
}

.dropZone:hover .dropZone-title {
  color: #1975A0;
}

.dropZone-info {
  color: #A8A8A8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.dropZone-title {
  color: #787878;
}

.dropZone input {
  position: absolute;
  cursor: pointer;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.dropZone-upload-limit-info {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

.dropZone-over {
  background: #5C5C5C;
  opacity: 0.8;
}

.dropZone-uploaded {
  width: 100%;
  height: 200px;
  position: relative;
  border: 2px dashed #eee;
}

.dropZone-uploaded-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #A8A8A8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

</style>
